import { ChangeEvent } from 'react';

import CheckIcon from '@mui/icons-material/Check';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import { Checkbox, FormGroup, FormControlLabel, SxProps, Theme } from '@mui/material';

const resolveSxOverrides = (sx: SxProps<Theme> | undefined, theme: Theme): SxProps<Theme> => {
  return typeof sx === 'function' ? sx(theme) : (sx ?? {});
};

export type CheckboxGroupProps = Readonly<{
  options: {
    label: string;
    value: string;
  }[];
  selectedValues?: string[];
  setSelectedValues?: (value: string[]) => void;
  disabled?: boolean;
  defaultChecked?: boolean;
  sxOverrides?: SxProps<Theme>;
}>;

export const CheckboxGroup = ({
  selectedValues,
  setSelectedValues,
  options,
  disabled,
  defaultChecked,
  sxOverrides,
}: CheckboxGroupProps) => {
  const formControl: SxProps<Theme> = (theme) => ({
    ...resolveSxOverrides(sxOverrides, theme),
  });

  const handleChange = (option: string) => (event: ChangeEvent<HTMLInputElement>) => {
    if (!setSelectedValues || !selectedValues) return;

    const updatedValues = event.target.checked
      ? [...selectedValues, option]
      : selectedValues.filter((value) => value !== option);

    setSelectedValues(updatedValues);
  };

  return (
    <FormGroup>
      {options.map((option) => (
        <FormControlLabel
          key={option.value}
          sx={formControl}
          checked={selectedValues?.includes(option.value)}
          control={
            <Checkbox
              icon={<CheckBoxOutlineBlankIcon />}
              checkedIcon={<CheckIcon />}
              onChange={handleChange(option.value)}
              disabled={disabled}
              defaultChecked={defaultChecked}
            />
          }
          label={option.label}
        />
      ))}
    </FormGroup>
  );
};
